const VolumeWidgetMute = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2307_6506)">
        <path
          d="M12 3V17C11.9995 17.1809 11.95 17.3583 11.8566 17.5133C11.7633 17.6682 11.6297 17.795 11.47 17.88C11.3136 17.9603 11.1389 17.9979 10.9633 17.9892C10.7877 17.9804 10.6176 17.9255 10.47 17.83L4.7 14H2C1.46957 14 0.960859 13.7893 0.585786 13.4142C0.210714 13.0391 0 12.5304 0 12V8C0 7.46957 0.210714 6.96086 0.585786 6.58579C0.960859 6.21071 1.46957 6 2 6H4.7L10.45 2.17C10.602 2.08223 10.7745 2.03603 10.95 2.03603C11.1255 2.03603 11.298 2.08223 11.45 2.17C11.6062 2.24825 11.7391 2.36606 11.8356 2.51168C11.9321 2.6573 11.9888 2.82567 12 3Z"
          fill="#8C8C8C"
        />
        <path
          d="M20 8L18.5858 6.58579L13.2401 11.9315L14.6543 13.3457L20 8Z"
          fill="#8C8C8C"
        />
        <path
          d="M14.5 6.5L13.0858 7.91421L18.6018 13.4303L20.016 12.016L14.5 6.5Z"
          fill="#8C8C8C"
        />
      </g>
      <defs>
        <clipPath id="clip0_2307_6506">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VolumeWidgetMute;
